module.exports = __webpack_public_path__ + "img/barcode-scanner.f025143e.png";